// import React, { useState } from 'react';
// import { URI } from '../../domain/constant';
// import { useMutation, useQueryClient } from '@tanstack/react-query';
// import api from '../../domain/api';
// import toast from 'react-hot-toast';
// import { uploadGallery } from '../../shared/upload';

// export default function EditGalleryForm({ galleryData, onClose }) {
//   console.log('EditGalleryForm data:', galleryData);

//   const [description, setDescription] = useState(
//     galleryData?.description || ''
//   );
//   const [images, setImages] = useState([]);

//   const [dbImages, setDbImages] = useState(galleryData?.image || []);

//   const queryClient = useQueryClient();

//   const [author, setAuthor] = useState(
//     galleryData?.author || 'Luhaif Digitech'
//   );

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     setImages((prev) => [...prev, ...files]);
//   };

//   const handleRemoveImage = (index) => {
//     setImages((prev) => prev.filter((_, i) => i !== index));
//   };

//   const mutation = useMutation({
//     mutationFn: async (data) =>
//       api.put(`/gallery/${galleryData._id}`, data).then((res) => res.data),

//     onSuccess: () => {
//       toast.success('Gallery entry updated successfully!');
//       // setDescription('');
//       // setImages([]);
//       // setDbImages([]);
//       // setAuthor('Luhaif Digitech');
//       queryClient.invalidateQueries({ queryKey: ['gallery'] });
//       if (onClose) onClose();
//     },
//     onError: (error) => {
//       toast.error(
//         error.response?.data?.message || 'Failed to update gallery entry'
//       );
//     },
//   });

//   const handleSubmit = async (e) => {
//     const uploadedImages = await uploadGallery(images);
//     mutation.mutate({
//       description,
//       image: [...dbImages, ...uploadedImages],
//       author,
//     });
//   };

//   return (
//     <div className='p-4'>
//       <h2>Edit Gallery Form</h2>

//       <div className='mb-3'>
//         <label className='form-label'>Description</label>
//         <textarea
//           className='form-control'
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           required
//           rows={3}
//           placeholder='Enter a description for the gallery entry...'
//         />
//       </div>

//       <div
//         // className='dropzone mb-3'
//         // onDrop={handleDrop}
//         // onDragOver={(e) => e.preventDefault()}
//         // onClick={() => document.getElementById('gallery-file-input').click()}
//         style={{ cursor: 'pointer' }}
//       >
//         <p
//           className='dropzone-text'
//           onClick={() => document.getElementById('gallery-file-input').click()}
//         >
//           Drag & drop images here, or{' '}
//           <span className='dropzone-browse'>browse</span>
//         </p>
//         <input
//           id='gallery-file-input'
//           type='file'
//           multiple
//           accept='image/*'
//           onChange={handleFileChange}
//           style={{ display: 'none' }}
//         />
//         {images.length > 0 && (
//           <div className='gallery-preview-grid'>
//             {images.map((img, idx) => (
//               <div className='gallery-preview-thumb' key={idx}>
//                 <img
//                   src={URL.createObjectURL(img)}
//                   alt={`preview-${idx}`}
//                   className='gallery-thumb-img'
//                   style={{ height: '40px', width: '40px' }}
//                 />
//                 <button
//                   type='button'
//                   className='remove-img-btn'
//                   onClick={() => handleRemoveImage(idx)}
//                   title='Remove image'
//                 >
//                   &times;
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}
//         <div className='image-preview-list mt-2'>
//           {dbImages.length > 0 &&
//             dbImages.map((img, idx) => (
//               <span key={idx} className='image-preview-item'>
//                 {/* <i className='fa fa-image' style={{ marginRight: 4 }}></i> */}
//                 <img
//                   src={URI + img}
//                   alt={img}
//                   style={{ height: '40px', width: '40px' }}
//                 />
//                 <button
//                   onClick={() =>
//                     setDbImages((prev) => prev.filter((d) => d !== img))
//                   }
//                 >
//                   Delete
//                 </button>
//               </span>
//             ))}
//         </div>
//       </div>

//       <div className='mb-3'>
//         <label className='form-label'>Author</label>
//         <input
//           type='text'
//           className='form-control'
//           value={author}
//           // readOnly

//           onChange={(e) => setAuthor(e.target.value)}
//         />
//       </div>

//       <button
//         type='submit'
//         className='btn btn-danger w-100'
//         style={{ fontWeight: 600, fontSize: 16 }}
//         onClick={handleSubmit}
//       >
//         Edit Gallery
//       </button>
//     </div>
//   );
// }

'use client';

import { useState } from 'react';
import { URI } from '../../domain/constant';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../domain/api';
import toast from 'react-hot-toast';
import { uploadGallery } from '../../shared/upload';

export default function EnhancedEditGalleryForm({ galleryData, onClose }) {
  const [description, setDescription] = useState(
    galleryData?.description || ''
  );
  const [images, setImages] = useState([]);
  const [dbImages, setDbImages] = useState(galleryData?.image || []);
  const [author, setAuthor] = useState(
    galleryData?.author || 'Luhaif Digitech'
  );
  const [isDragOver, setIsDragOver] = useState(false);

  const queryClient = useQueryClient();

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files).filter((file) =>
      file.type.startsWith('image/')
    );
    setImages((prev) => [...prev, ...files]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files).filter((file) =>
      file.type.startsWith('image/')
    );
    setImages((prev) => [...prev, ...files]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveDbImage = (imageToRemove) => {
    setDbImages((prev) => prev.filter((img) => img !== imageToRemove));
  };

  const mutation = useMutation({
    mutationFn: async (data) =>
      api.put(`/gallery/${galleryData._id}`, data).then((res) => res.data),
    onSuccess: () => {
      toast.success('Gallery entry updated successfully!');
      queryClient.invalidateQueries({ queryKey: ['gallery'] });
      if (onClose) onClose();
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || 'Failed to update gallery entry'
      );
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!description.trim()) {
      toast.error('Please enter a description');
      return;
    }

    const uploadedImages = await uploadGallery(images);
    mutation.mutate({
      description,
      image: [...dbImages, ...uploadedImages],
      author,
    });
  };

  return (
    <>
      <div className='compact-edit-modal-overlay' onClick={onClose}>
        <div
          className='compact-edit-modal-container'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='compact-edit-modal-card'>
            {/* Compact Header */}
            <div className='compact-edit-header'>
              <div className='compact-edit-header-content'>
                <div className='compact-edit-header-icon'>
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z'
                      stroke='currentColor'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>
                <div>
                  <h3 className='compact-edit-title'>Edit Gallery</h3>
                  <p className='compact-edit-subtitle'>
                    Update gallery content
                  </p>
                </div>
              </div>
              <button className='compact-edit-close' onClick={onClose}>
                <svg width='18' height='18' viewBox='0 0 24 24' fill='none'>
                  <path
                    d='M18 6L6 18M6 6L18 18'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} className='compact-edit-form'>
              {/* Description Field */}
              <div className='compact-form-group'>
                <label className='compact-form-label'>Description</label>
                <textarea
                  className='compact-form-textarea'
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                  rows={3}
                  placeholder='Update the description...'
                />
              </div>

              {/* Current Images - Compact View */}
              {dbImages.length > 0 && (
                <div className='compact-form-group'>
                  <label className='compact-form-label'>
                    Current Images ({dbImages.length})
                  </label>
                  <div className='compact-current-images'>
                    {dbImages.map((img, idx) => (
                      <div className='compact-current-image' key={idx}>
                        <img
                          src={URI + img || '/placeholder.svg'}
                          alt={`current-${idx}`}
                          className='compact-current-img'
                        />
                        <button
                          type='button'
                          className='compact-remove-btn'
                          onClick={() => handleRemoveDbImage(img)}
                          title='Remove image'
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Add New Images - Compact */}
              <div className='compact-form-group'>
                <label className='compact-form-label'>Add New Images</label>
                <div
                  className={`compact-dropzone ${
                    isDragOver ? 'drag-over' : ''
                  }`}
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onClick={() =>
                    document.getElementById('compact-file-input').click()
                  }
                >
                  <div className='compact-dropzone-content'>
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                      <path
                        d='M21 15V19C21 20.105 20.105 21 19 21H5C3.895 21 3 20.105 3 19V15M17 8L12 3M12 3L7 8M12 3V15'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    <p className='compact-dropzone-text'>
                      {isDragOver
                        ? 'Drop here'
                        : 'Drop files or click to browse'}
                    </p>
                  </div>

                  <input
                    id='compact-file-input'
                    type='file'
                    multiple
                    accept='image/*'
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                  />
                </div>

                {/* New Images Preview - Compact */}
                {images.length > 0 && (
                  <div className='compact-new-images'>
                    {images.map((img, idx) => (
                      <div className='compact-new-image' key={idx}>
                        <img
                          src={URL.createObjectURL(img) || '/placeholder.svg'}
                          alt={`new-${idx}`}
                          className='compact-new-img'
                        />
                        <button
                          type='button'
                          className='compact-remove-btn'
                          onClick={() => handleRemoveImage(idx)}
                          title='Remove image'
                        >
                          ×
                        </button>
                        <span className='compact-image-name'>{img.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Author Field */}
              <div className='compact-form-group'>
                <label className='compact-form-label'>Author</label>
                <input
                  type='text'
                  className='compact-form-input'
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
                  placeholder='Enter author name'
                />
              </div>

              {/* Compact Action Buttons */}
              <div className='compact-actions'>
                <button
                  type='button'
                  className='compact-cancel-btn'
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='compact-submit-btn'
                  disabled={mutation.isLoading}
                >
                  {mutation.isLoading ? (
                    <>
                      <div className='compact-spinner'></div>
                      Updating...
                    </>
                  ) : (
                    'Update Gallery'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .compact-edit-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 15px;
        }

        .compact-edit-modal-container {
          width: 100%;
          max-width: 500px;
          max-height: 85vh;
          overflow-y: auto;
        }

        .compact-edit-modal-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .compact-edit-header {
          background: linear-gradient(
            135deg,
            #1f2937 0%,
            #374151 30%,
            #dc2626 70%,
            #b91c1c 100%
          );
          color: white;
          padding: 20px 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .compact-edit-header-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .compact-edit-header-icon {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .compact-edit-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 2px 0;
        }

        .compact-edit-subtitle {
          font-size: 12px;
          opacity: 0.9;
          margin: 0;
        }

        .compact-edit-close {
          background: rgba(255, 255, 255, 0.1);
          border: none;
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease;
        }

        .compact-edit-close:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .compact-edit-form {
          padding: 25px;
        }

        .compact-form-group {
          margin-bottom: 20px;
        }

        .compact-form-label {
          display: block;
          font-weight: 600;
          color: #374151;
          margin-bottom: 8px;
          font-size: 13px;
        }

        .compact-form-input,
        .compact-form-textarea {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.2s ease;
          background: #fafafa;
        }

        .compact-form-input:focus,
        .compact-form-textarea:focus {
          outline: none;
          border-color: #dc2626;
          background: white;
          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
        }

        .compact-form-textarea {
          resize: vertical;
          min-height: 60px;
        }

        .compact-current-images,
        .compact-new-images {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 8px;
        }

        .compact-current-image,
        .compact-new-image {
          position: relative;
          width: 60px;
          height: 60px;
          border-radius: 6px;
          overflow: hidden;
          background: #f3f4f6;
        }

        .compact-current-img,
        .compact-new-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .compact-remove-btn {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #dc2626;
          color: white;
          border: none;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .compact-remove-btn:hover {
          background: #b91c1c;
          transform: scale(1.1);
        }

        .compact-dropzone {
          border: 2px dashed #d1d5db;
          border-radius: 8px;
          background: #fafafa;
          padding: 20px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .compact-dropzone:hover,
        .compact-dropzone.drag-over {
          border-color: #dc2626;
          background: #fef2f2;
        }

        .compact-dropzone-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          color: #6b7280;
        }

        .compact-dropzone:hover .compact-dropzone-content,
        .compact-dropzone.drag-over .compact-dropzone-content {
          color: #dc2626;
        }

        .compact-dropzone-text {
          font-size: 13px;
          margin: 0;
        }

        .compact-new-image {
          display: flex;
          flex-direction: column;
          width: 80px;
        }

        .compact-image-name {
          font-size: 10px;
          color: #6b7280;
          margin-top: 4px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-align: center;
        }

        .compact-actions {
          display: flex;
          gap: 10px;
          margin-top: 25px;
        }

        .compact-cancel-btn {
          flex: 1;
          background: #f3f4f6;
          color: #374151;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          padding: 10px 16px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .compact-cancel-btn:hover {
          background: #e5e7eb;
        }

        .compact-submit-btn {
          flex: 2;
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          color: white;
          border: none;
          border-radius: 8px;
          padding: 10px 16px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
        }

        .compact-submit-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
        }

        .compact-submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .compact-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @media (max-width: 768px) {
          .compact-edit-modal-overlay {
            padding: 10px;
          }

          .compact-edit-modal-container {
            max-width: 95vw;
          }

          .compact-edit-header {
            padding: 15px 20px;
          }

          .compact-edit-form {
            padding: 20px;
          }

          .compact-current-images,
          .compact-new-images {
            gap: 6px;
          }

          .compact-current-image,
          .compact-new-image {
            width: 50px;
            height: 50px;
          }

          .compact-actions {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
}
